import { Editor, Transforms, Path, Range, Element } from 'slate';
import { ReactEditor } from 'slate-react';

export const insertLink = (editor: ReactEditor, { href, text }: { href: string; text: string }) => {
  if (!href) return;

  const { selection } = editor;
  const link = {
    type: 'link',
    href,
    children: [{ text }],
  };

  if (selection) {
    const [parent, parentPath] = Editor.parent(editor, selection.focus.path);
    // @ts-ignore
    if (parent.type === 'link') {
      removeLink(editor);
    }

    if (editor.isVoid(parent)) {
      Transforms.insertNodes(
        editor,
        // @ts-ignore
        { type: 'paragraph', children: [link] },
        {
          at: Path.next(parentPath),
          select: true,
        },
      );
    } else if (Range.isCollapsed(selection)) {
      Transforms.insertNodes(editor, link, { select: true });
    } else {
      Transforms.wrapNodes(editor, link, { split: true });
    }
  } else {
    // @ts-ignore
    Transforms.insertNodes(editor, { type: 'paragraph', children: [link] });
  }
};

export const removeLink = (editor: ReactEditor) => {
  Transforms.unwrapNodes(editor, {
    match: n =>
      !Editor.isEditor(n) &&
      Element.isElement(n) &&
      // @ts-ignore
      n.type === 'link',
  });
};

const isLink = (editor: ReactEditor) => {
  // @ts-ignore
  const [match] = Editor.nodes(editor, {
    // @ts-ignore
    match: n => !Editor.isEditor(n) && Element.isElement(n) && n.type === 'link',
  });

  return !!match;
};

export const withLinks = (editor: ReactEditor) => {
  // (note - pearl) This ensures 'split' when creating links won't split up text on the same line
  const { isInline } = editor;
  editor.isInline = (element: any) => (element.type === 'link' ? true : isInline(element));

  // (note - pearl) This ensures entering the next line would exit the current link
  const { insertBreak } = editor;
  editor.insertBreak = () => {
    const { selection } = editor;
    if (selection) {
      if (isLink(editor)) {
        Transforms.insertNodes(editor, {
          children: [{ text: '' }],
        });

        return;
      }
    }

    insertBreak();
  };

  // (note - pearl) This ensures deleting links would remove them (instead of leaving a link with
  // empty text content)
  const { deleteBackward } = editor;
  editor.deleteBackward = () => {
    const { selection } = editor;
    if (selection) {
      if (isLink(editor)) {
        removeLink(editor);
      }
    }

    deleteBackward('character');
  };

  return editor;
};
